import CrudBase from '../../CrudBase';
import axios from '../../../axios-common';

class CustomerApi extends CrudBase {
	getCustomerOrders = (params) => axios.get(`${this.endpoint}/orders`, params);
	getSaleFrequency = (params) =>
		axios.get(`${this.endpoint}/sale-frequency`, params);
	getCustomerOrdersServed = (date, params) =>
		axios.get(`${this.endpoint}/served?date=${date}`, params);
	updateCustomer = (data) => axios.post(`${this.endpoint}/update`, data);

	defaultMethods = {
		...this.defaultMethods,
		getCustomerOrders: this.getCustomerOrders,
		getSaleFrequency: this.getSaleFrequency,
		getCustomerOrdersServed: this.getCustomerOrdersServed,
		updateCustomer: this.updateCustomer,
	};
}

const customer = new CustomerApi('api/v1/customer');

export default customer.defaultMethods;
